import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  removePresentation,
  copyPresentation,
  markAsSeen,
  markAsUnseen
} from '../../../../../../../../stores/shared-presentations/shared-presentations.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getPresentation } from '../../../../../../../../stores/shared-presentations/shared-presentations.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id }) => {
  const sharedPresentation = getPresentation(state, id)
  return {
    seen: sharedPresentation.seen,
    actualPresentationId: sharedPresentation.presentation.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onRemove: () =>
    dispatch(removePresentation(ownProps.id, stateProps.seen)).catch(
      errorHandler
    ),
  onMarkAsSeen: () => dispatch(markAsSeen(ownProps.id)).catch(errorHandler),
  onMarkAsUnseen: () => dispatch(markAsUnseen(ownProps.id)).catch(errorHandler),
  onCopy: () =>
    dispatch(copyPresentation(ownProps.id, stateProps.actualPresentationId))
      .then(() => dispatch(markAsSeen(ownProps.id)).catch(errorHandler))
      .then(() => ownProps.history.push('/'))
      .catch(errorHandler)
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
